import React from 'react';
import PropTypes from 'prop-types';
import { getUniqueId } from '../../helpers';
import { StyledLabel } from './styled';

function Switch({ id, value, checked, label, onClick, onChange, className }) {
    const checkboxId = id || getUniqueId('checkbox');

    return (
        <div className={className}>
            <div className="form-check d-inline-block custom-control custom-switch mb-4 ml-2">
                <input
                    id={checkboxId}
                    className="custom-control-input"
                    type="checkbox"
                    value={value}
                    checked={checked}
                    onClick={e => onClick(e.currentTarget.checked)}
                    onChange={onChange}
                    style={{ top: 'inherit !important' }}
                />
                <StyledLabel
                    className="form-check-label custom-control-label text-app-gray app-font-14 font-weight-500"
                    htmlFor={checkboxId}
                >
                    {label}
                </StyledLabel>
            </div>
        </div>
    );
}

Switch.propTypes = {
    id: PropTypes.string,
    value: PropTypes.string,
    checked: PropTypes.bool,
    label: PropTypes.string,
    onClick: PropTypes.func,
    onChange: PropTypes.func,
    className: PropTypes.string,
};

Switch.defaultProps = {
    id: '',
    value: '',
    checked: false,
    label: '',
    onClick: () => {},
    onChange: () => {},
    className: '',
};

export default Switch;
